import React from 'react';
import ReactSelect, {
  GroupBase,
  Props as ReactSelectProps
} from 'react-select';
import { clsx } from 'clsx';

import styles from './DropdownSelect.module.scss';

/**
 * DEPRECATED: Use `@strava/ui/Select` instead.
 */

export type DropdownSelectProps<
  OptionType,
  IsMulti extends boolean = false,
  GroupType extends GroupBase<OptionType> = GroupBase<OptionType>
> = ReactSelectProps<OptionType, IsMulti, GroupType> & {
  ariaLabel?: string;
};

export const DropdownSelect = <
  OptionType,
  IsMulti extends boolean = false,
  GroupType extends GroupBase<OptionType> = GroupBase<OptionType>
>({
  className = '',
  ...props
}: DropdownSelectProps<OptionType, IsMulti, GroupType>) => {
  return (
    <ReactSelect
      className={clsx(styles.reactSelectContainer, className)}
      classNamePrefix="react-select"
      {...props}
    />
  );
};
